module.exports = __webpack_public_path__ + "static/img/logo1.17afaae2.png";